import { flip, offset, useFloating, UseFloatingReturn } from '@floating-ui/react';

export const useTypeaheadFloating = (): UseFloatingReturn => {
  return useFloating({
    placement: 'bottom-start',
    middleware: [
      flip(),
      offset(({ rects, placement }) => {
        const verticalOffset = placement.includes('top') ? 1 : -1;

        return (
          rects.reference.height * verticalOffset
        );
      }),
    ],
  });
};
